<template>
  <div>
    <div class="mx-auto mt-16 pt-2" :class="isMobile ? 'w-full px-2' : 'section'">
      <button class="w-20 px-3 mb-2 font-bold border-2 rounded-md bg-white cursor-pointer" @click="back()">
        ＜戻る
      </button>
      <div class="mt-2" :class="isMobile ? 'text-sm p-1' : 'pb-1'">
        現在お持ちの定期券の有効期間終了日と、新しい定期券の有効期間開始日を入力し、「この内容で計算」ボタンを押してください。<br />
        ※「2区間定期券」をお持ちの方は「2区間目の追加」ボタンから入力してください。
      </div>
      <div class="w-full base-color min-h-10 mt-4">
        <div v-if="type === 'before'" class="float-left ml-2 bg-blue-600 text-white my-2 px-4 rounded-full">
          <span v-if="mode === 'fare'">
            改定前運賃
          </span>
          <span v-else>
            改定前定期運賃
          </span>
        </div>
        <div v-else class="float-left ml-2 bg-red-600 text-white my-2 px-4 rounded-full">
          <span v-if="mode === 'fare'">
            改定後運賃
          </span>
          <span v-else>
            改定後定期運賃
          </span>
        </div>
        <div v-for="(s, index) in viaList" v-bind:key="index" class="float-left font-bold my-2 text-white">
          <div v-if="index > 0" class="float-left ml-2">
            →
          </div>
          <div class="float-left ml-2">
            {{ s }}
          </div>
        </div>
        <div class="clear-both"></div>
      </div>
      <div class="text-center mx-auto mt-2">
        <div id="result" ref="result">
        </div>
      </div>
      <div v-if="serializeData.length === 1" class="text-center mx-auto mt-2">
        <button class="font-bold text-xl w-64 rounded-md py-1 text-white bg-blue-600" @click="addTeiki()">
          2区間目の追加
        </button>
      </div>
      <div v-if="resultErrors.length > 0" class="font-bold text-red-500">
        <div class="ml-6">
          <div v-for="(error, index) in resultErrors" :key="index" type="1" v-html="error"></div>
        </div>
      </div>
      <div v-else class="mt-2">
        <div>
          <div class="font-bold float-left pt-.5">現在お持ちの定期券の有効月数：</div>
          {{ teikiValidity }}ヶ月
        </div>
        <div class="float-left">
          <div class="font-bold float-left pt-.5">現在お持ちの定期券の有効終了日：</div>
          <input v-model="expire" type="date" class="border-2 rounded mr-2" @change="reset">
        </div>
        <div class="float-left">
          <div class="font-bold float-left pt-.5">新定期券の有効開始日：</div>
          <input v-model="start" type="date" class="border-2 rounded mr-2" @change="reset">
        </div>
        <div v-if="showStartDate" class="clear-both">
          <span class="text-red-500">
            本日お求めいただけるのは{{ showStartDate.replace(/-/g, '/') }}有効開始となる定期券までです。
          </span>
        </div>
        <div class="clear-both">
          運賃改定前には、3月27日から有効開始となる定期券までお求めいただけます。
        </div>
        <div class="text-center mx-auto mt-2">
          <button class="font-bold text-xl w-64 rounded-md py-1 text-white bg-blue-600" @click="calculation()">
            この内容で計算
          </button>
        </div>
      </div>
      <div ref="calculate"></div>
      <div v-if="errors.length > 0" class="font-bold text-red-500 mt-2">
        <div class="ml-6">
          <div v-for="(error, index) in errors" :key="index" type="1" v-html="error"></div>
        </div>
      </div>
      <div v-else-if="showResult" class="mt-4">
        <div class="my-2 text-2xl">
          <span class="font-bold">※改定前運賃で購入できる日</span> {{ getPurchaseDate().replace(/\-/g, '/') }} から 2026/03/13 まで
        </div>
        <div class="hidden">
          次の計算式に従って判定を行います。
          <div class="text-sm"><span class="teiki-calc-a-font font-bold">A</span>（改定後の定期券発売額 ― 改定前の定期券発売額）</div>
          <div class="text-sm"><span class="teiki-calc-b-font font-bold">B</span>（新定期券の有効開始日から現在お持ちの定期券の有効終了日の重複期間 ×
            現在お持ちの定期券の日割り運賃）</div>
        </div>
        <template v-if="isMobile">
          <div class="clear-both">
            <div class="w-24 float-left">
              <div class="teiki-cell teiki-new-label text-white">新定期券</div>
              <div class="teiki-cell teiki-new-value">{{ (getTotalNewTeikiSummary()).toLocaleString() }}円</div>
            </div>
            <div class="w-8 float-left text-center text-blue-700 mt-2 calc">
              ー
            </div>
            <div class="w-24 float-left">
              <div class="teiki-cell teiki-new-label text-white">旧定期券</div>
              <div class="teiki-cell teiki-new-value">{{ (getTotalOldTeikiSummary()).toLocaleString() }}円</div>
            </div>
            <div class="w-8 float-left text-center text-blue-700 mt-2 calc">
              ＝
            </div>
            <div class="w-24 float-left">
              <div class="teiki-cell teiki-calc-a h-18">
                <div class="mt-1.5">A</div>
                <div class="text-black">{{ (getTeikiDifference()).toLocaleString() }}円</div>
              </div>
            </div>
          </div>
          <div class="clear-both">
            <div class="w-24 float-left">
              <div class="teiki-cell teiki-old-label text-white">放棄日数</div>
              <div class="teiki-cell teiki-old-value">{{ getNumberOfDays() }}日</div>
            </div>
            <div class="w-8 float-left text-center text-red-700 mt-2 calc">
              ×
            </div>
            <div class="w-24 float-left">
              <div class="teiki-cell teiki-old-label text-white">1日当たりの運賃</div>
              <div class="teiki-cell teiki-old-value">{{ (getTotalDailyRate()).toLocaleString() }}円</div>
            </div>
            <div class="w-8 float-left text-center text-red-700 mt-2 calc">
              ＝
            </div>
            <div class="w-24 float-left">
              <div class="teiki-cell teiki-calc-b h-18">
                <div class="mt-1.5">B</div>
                <div class="text-black">{{ (getTotalRate()).toLocaleString() }}円</div>
              </div>
            </div>
          </div>
          <div class="clear-both">
            <div class="w-24 float-left">
              <div class="teiki-cell teiki-calc-a">A</div>
            </div>
            <div class="w-8 float-left text-center calc">
              ー
            </div>
            <div class="w-24 float-left">
              <div class="teiki-cell teiki-calc-b">B</div>
            </div>
            <div class="w-8 float-left text-center calc">
              ＝
            </div>
            <div class="w-24 float-left">
              <div class="teiki-cell teiki-calc-c">{{ (getAmountRemaining()).toLocaleString() }}円</div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="clear-both">
            <div class="w-48 float-left">
              <div class="teiki-cell teiki-new-label text-white">新定期券</div>
              <div class="teiki-cell teiki-new-value">{{ (getTotalNewTeikiSummary()).toLocaleString() }}円</div>
            </div>
            <div class="w-12 float-left text-center text-blue-700 mt-2 calc">
              ー
            </div>
            <div class="w-48 float-left">
              <div class="teiki-cell teiki-new-label text-white">旧定期券</div>
              <div class="teiki-cell teiki-new-value">{{ (getTotalOldTeikiSummary()).toLocaleString() }}円</div>
            </div>
            <div class="w-12 float-left text-center text-blue-700 mt-2 calc">
              ＝
            </div>
            <div class="w-48 float-left">
              <div class="teiki-cell teiki-calc-a h-18">
                <div class="mt-1.5">A</div>
                <div class="text-black">{{ (getTeikiDifference()).toLocaleString() }}円</div>
              </div>
            </div>
          </div>
          <div class="clear-both">
            <div class="w-48 float-left">
              <div class="teiki-cell teiki-old-label text-white">放棄日数</div>
              <div class="teiki-cell teiki-old-value">{{ getNumberOfDays() }}日</div>
            </div>
            <div class="w-12 float-left text-center text-red-700 mt-2 calc">
              ×
            </div>
            <div class="w-48 float-left">
              <div class="teiki-cell teiki-old-label text-white">1日当たりの運賃</div>
              <div class="teiki-cell teiki-old-value">{{ (getTotalDailyRate()).toLocaleString() }}円</div>
            </div>
            <div class="w-12 float-left text-center text-red-700 mt-2 calc">
              ＝
            </div>
            <div class="w-48 float-left">
              <div class="teiki-cell teiki-calc-b h-18">
                <div class="mt-1.5">B</div>
                <div class="text-black">{{ (getTotalRate()).toLocaleString() }}円</div>
              </div>
            </div>
          </div>
          <div class="clear-both">
            <div class="w-48 float-left">
              <div class="teiki-cell teiki-calc-a">A</div>
            </div>
            <div class="w-12 float-left text-center calc">
              ー
            </div>
            <div class="w-48 float-left">
              <div class="teiki-cell teiki-calc-b">B</div>
            </div>
            <div class="w-12 float-left text-center calc">
              ＝
            </div>
            <div class="w-48 float-left">
              <div class="teiki-cell teiki-calc-c">{{ (getAmountRemaining()).toLocaleString() }}円</div>
            </div>
          </div>
        </template>
        <div class="clear-both">
          <div class="w-1/3 float-left">
            <div class="bg-green-500 text-white text-center font-bold py-1">判定</div>
          </div>
          <div class="w-2/3 float-left">
            <div class="px-2 bg-white text-center font-bold text-2xl">{{ getJudgment() }}</div>
          </div>
        </div>
        <div class="clear-both"></div>
        <div class="mt-4 mb-2">
          <span class="teiki-calc-a font-bold px-8">A</span> ―
          <span class="teiki-calc-b font-bold px-8">B</span>
          が0円以下の場合は「現在の定期券を引き続きご利用ください。」<br />
          1円以上の場合は「新しい定期券を運賃改定前にお求めください。」を表示します。
        </div>
        <div v-if="getAmountRemaining() > 0">
          ※運賃改定前の定期券の具体的な購入方法は、
          <a href="https://www.jreast.co.jp/2026unchin-kaitei/#howto" target="_blank"
            class="text-blue-600 underline">こちらのページ</a>
          をご参照ください。
        </div>
      </div>
      <div class="text-center mb-2 font-bold text-blue-600 underline break-all cursor-pointer mt-2" @click="top()">
        ←TOPに戻る
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Constants from '@/constants';

export default {
  data() {
    return {
      result: null,
      expire: "2026-03-31",
      start: "2026-03-27",
      showStartDate: null,
      validity: "1",
      errors: [],
      resultErrors: [],
      courses: [],
      showResult: false,
    }
  },
  computed: mapGetters({
    viaList: 'getViaList',
    mode: 'getMode',
    type: 'getType',
    teikiKind: 'getTeikiKind',
    teikiValidity: 'getTeikiValidity',
    isMobile: 'getIsMobile',
    serializeData: 'getSerializeData',
  }),
  async mounted() {
    this.validity = this.teikiValidity;
    const now = new Date().toISOString().substring(0, 10);
    const d = new Date(now);
    d.setDate(d.getDate() + 14);
    this.showStartDate = d.toISOString().substring(0, 10);
    if (now >= '2026-03-09') {
      this.start = d.toISOString().substring(0, 10);
    }
    if (this.serializeData.length > 2) {
      this.$store.commit('sliceSerializeData', 2);
    }
    this.result = new window.expGuiCourse(this.$refs.result);
    this.result.setConfigure("CourseDisplay", 'all');
    if (this.isMobile) {
      this.result.setConfigure("agent", 2);
    } else {
      this.result.setConfigure("agent", 1);
    }
    this.$store.commit('setIsLoading', true);
    try {
      if (this.serializeData.length > 0) {
        await this.searchSerializeData(this.serializeData[0]);
        if (this.serializeData.length === 2) {
          await this.searchSerializeData(this.serializeData[1]);
        }
        let data = {
          ResultSet: {
            Course: [this.courses[0][0]]
          }
        };
        if (this.serializeData.length === 2) {
          data.ResultSet.Course.push(this.courses[1][0]);
        }
        this.result.setResult(data, this.mode === 'teiki' ? this.result.PRICE_TEIKI : undefined);
        this.checkResultErrors();
      } else {
        this.resultErrors = [
          'ご入力の経路が見つかりませんでした。',
          'TOPに戻ってやり直してください。',
        ];
      }
    } catch (response) {
      console.log(response);
    } finally {
      this.$store.commit('setIsLoading', false);
    }
  },
  methods: {
    searchSerializeData: async function (serializeData) {
      const response = await this.request('get', Constants.API_BASE_URL + 'v1/json/course/edit?serializeData=' + serializeData);
      const result = response.data;
      if (result.ResultSet.Course) {
        for (let c of result.ResultSet.Course) {
          this.setEmptyPrice(c.Price, this.validity);
        }
        this.courses.push(result.ResultSet.Course);
      } else {
        this.resultErrors = [
          'ご入力の経路が見つかりませんでした。',
          '下記をご確認ください。',
          '1.定期券が発行できない区間が含まれている',
          '2.最初の区間がJR以外になっている',
        ];
      }
    },
    checkResultErrors: function () {
      if (this.courses.length == 2) {
        if ((this.courses[0][0].isJrOffpeakTeiki === 'true' || this.courses[1][0].isJrOffpeakTeiki === 'true') && (this.courses[0][0].isJrOffpeakTeiki === 'false' || this.courses[1][0].isJrOffpeakTeiki === 'false')) {
          this.resultErrors = [
            '通常の定期とオフピーク定期が混在している場合は計算できません。',
            '戻るボタンで定期券を変更するか、TOPに戻ってやり直してください。。',
          ];
        }
      }
    },
    getPurchaseDate: function () {
      const purchaseDate = new Date(this.start);
      purchaseDate.setDate(purchaseDate.getDate() - 14);
      return purchaseDate.toISOString().substring(0, 10).replace(/-/g, '/');
    },
    calculation: function () {
      this.errors.splice(0);
      if (this.getOldTeikiSummary(0) > 0 && (this.serializeData.length === 1 || this.getOldTeikiSummary(1) > 0)) {
        if (this.start) {
          const startDate = parseInt(this.start.replace(/-/g, ''), 10);
          if (startDate >= 20260328) {
            this.errors.push('3/28以降有効開始の定期券は、改定前運賃ではお求めいただけません。');
          }
          const expireDate = new Date(this.expire);
          if (expireDate < new Date('2026-03-27')) {
            expireDate.setDate(expireDate.getDate() - 14);
            this.errors.push('入力された定期券は、「' + expireDate.toISOString().substring(0, 10).replace(/-/g, '/') + '」以降、券売機等での継続購入が可能です。');
          }
        }
        this.showResult = true;
        // 非同期にてスクロールする必要あり
        window.setTimeout(() => {
          this.$refs['calculate'].scrollIntoView({ behavior: 'smooth' });
        }, 100);
      } else {
        this.errors = [
          'ご入力の購入月数の定期券の料金が取得できませんでした。',
        ];
      }
    },
    addTeiki: function () {
      this.$router.push({ name: 'AddTeiki' });
    },
    reset: function () {
      this.errors.splice(0);
      this.showResult = false;
    },
    getNumberOfDays: function () {
      const start = new Date(this.start);
      const expire = new Date(this.expire);
      const days = (expire - start) / 86400000 + 1;
      return days > 0 ? days : 0;
    },
    getDailyRate: function (index) {
      let rate = 0;
      if (this.courses[index]) {
        if (this.validity === "1") {
          rate = Math.ceil(this.getOldTeikiSummary(index) / 30);
        } else if (this.validity === "3") {
          rate = Math.ceil(this.getOldTeikiSummary(index) / 90);
        } else if (this.validity === "6") {
          rate = Math.ceil(this.getOldTeikiSummary(index) / 180);
        }
      }
      return rate;
    },
    getTotalDailyRate: function () {
      return this.getDailyRate(0) + this.getDailyRate(1);
    },
    getTotalRate: function () {
      return this.getDailyRate(0) * this.getNumberOfDays() + this.getDailyRate(1) * this.getNumberOfDays();
    },
    getOldTeikiSummary: function (index) {
      if (this.courses[index]) {
        let totalPrice;
        if (this.validity === "1") {
          totalPrice = this.courses[index][0].Price.find(p => p.kind === "Teiki1Summary");
        } else if (this.validity === "3") {
          totalPrice = this.courses[index][0].Price.find(p => p.kind === "Teiki3Summary");
        } else if (this.validity === "6") {
          totalPrice = this.courses[index][0].Price.find(p => p.kind === "Teiki6Summary");
        }
        if (totalPrice) {
          return parseInt(totalPrice.Oneway, 10);
        }
      }
      return 0;
    },
    getNewTeikiSummary: function (index) {
      if (this.courses[index]) {
        let totalPrice;
        if (this.validity === "1") {
          totalPrice = this.courses[index][1].Price.find(p => p.kind === "Teiki1Summary");
        } else if (this.validity === "3") {
          totalPrice = this.courses[index][1].Price.find(p => p.kind === "Teiki3Summary");
        } else if (this.validity === "6") {
          totalPrice = this.courses[index][1].Price.find(p => p.kind === "Teiki6Summary");
        }
        if (totalPrice) {
          return parseInt(totalPrice.Oneway, 10);
        }
      }
      return 0;
    },
    getTotalOldTeikiSummary: function () {
      return this.getOldTeikiSummary(0) + this.getOldTeikiSummary(1);
    },
    getTotalNewTeikiSummary: function () {
      return this.getNewTeikiSummary(0) + this.getNewTeikiSummary(1);
    },
    getTeikiDifference: function () {
      return this.getNewTeikiSummary(0) + this.getNewTeikiSummary(1) - this.getOldTeikiSummary(0) - this.getOldTeikiSummary(1);
    },
    getAmountRemaining: function () {
      return this.getTeikiDifference() - this.getTotalRate();
    },
    getJudgment: function () {
      return this.getAmountRemaining() > 0 ? '新しい定期券を運賃改定前にお求めください。' : '現在の定期券を引き続きご利用ください。';
    },
    back: function () {
      if (this.serializeData.length === 1) {
        this.$store.commit('sliceSerializeData', 0);
        this.$router.push({ name: 'TeikiList' });
      } else {
        this.$store.commit('sliceSerializeData', 1);
        this.$router.push({ name: 'AddTeikiList' });
      }
    },
    top: function () {
      this.$store.commit('reset');
      this.$router.push({ name: 'TeikiTop' });
    },
  }
}
</script>

<style scoped>
.teiki-new-label {
  background-color: #0f9ed5;
}

.teiki-new-value {
  background-color: #ccdfef;
}

.teiki-old-label {
  background-color: #e97132;
}

.teiki-old-value {
  background-color: #f7d5cd;
}

.teiki-cell {
  font-weight: 700;
  text-align: center;
  margin: 3px;
  padding: 5px;
}

.calc {
  font-weight: 800;
  font-size: 32px;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: black;
}

.teiki-calc-a-font {
  color: #0f9ed5;
}

.teiki-calc-b-font {
  color: #e97132;
}

.teiki-calc-a {
  border-color: #0f9ed5;
  border-width: 1px;
  color: #0f9ed5;
}

.teiki-calc-b {
  border-color: #e97132;
  border-width: 1px;
  color: #e97132;
}

.teiki-calc-c {
  border-color: #4ea72e;
  border-width: 1px;
  /* color:#4ea72e; */
}

.h-18 {
  height: 4.5rem;
}
</style>
